import { render, staticRenderFns } from "./crimetypes.vue?vue&type=template&id=5c4e9da7"
import script from "./crimetypes.vue?vue&type=script&lang=js"
export * from "./crimetypes.vue?vue&type=script&lang=js"
import style0 from "./crimetypes.vue?vue&type=style&index=0&id=5c4e9da7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports